import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaQrcode,
  FaCopy,
  FaCheck,
  FaShieldAlt,
  FaFilePdf,
  FaDownload,
} from "react-icons/fa";
import { SiGooglepay } from "react-icons/si";
import WhatsAppButton from "./Whatsapp";

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeQr, setActiveQr] = useState("primary"); // "primary" = GMR Crackers, "alternate" = Hari Kd
  const [copied, setCopied] = useState(false);

  const handlenavigate = () => {
    navigate("/products");
  };

  const primaryUpi = "rakeshmahesh2010-1@okaxis";
  const alternateUpi = "harikdv2-1@okicici";
  const currentUpi = activeQr === "primary" ? primaryUpi : alternateUpi;

  const handleCopyUpi = () => {
    navigator.clipboard.writeText(currentUpi);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };

  return (
    <>
      {location.pathname !== "/products" && location.pathname !== "/" && (
        <div className="fixed point2 blink" onClick={handlenavigate} title="View Price List">
          <img
            src={require("../../assets/images/flash.png")}
            className="img-fluid priceicn2 float-right"
            alt="special price"
          />
        </div>
      )}
      <div className="fixed point">
        <WhatsAppButton name="GMR Crackers" phoneNumber="919843058048" />
      </div>
      <a href="https://maps.app.goo.gl/1BLGE7CNe98jnJ3AA" target="_blank" rel="noopener noreferrer" title="Google Map Location">
        <div className="fixed point3" style={{ cursor: "pointer" }}>
          <img
            src={require("../../assets/images/googlelocation.png")}
            className="img-fluid priceicn float-left"
            alt="google location"
          />
        </div>
      </a>
      <a href="tel:+919843058048" title="Call Us">
        <div className="fixed point4" style={{ cursor: "pointer" }}>
          <img
            src={require("../../assets/images/callicon.webp")}
            className="img-fluid priceicn float-left"
            alt="call icon"
          />
        </div>
      </a>

      {/* Modern Animated Download Price List 2026 Button (Directly Above Call Us) */}
      <a
        href="/gmr_crackers_pricelist_2026.pdf"
        download="GMR_Crackers_Price_List_2026.pdf"
        title="Download GMR Crackers 2026 Official Price List PDF (80% Off)"
        className="fixed point5 text-decoration-none"
      >
        <div className="download-floating-stack-btn d-flex align-items-center shadow-lg">
          <div className="download-stack-icon d-flex align-items-center justify-content-center">
            <FaFilePdf size={20} />
          </div>
          <div className="download-stack-text d-flex flex-column text-start">
            <span className="download-stack-title">Price List 2026</span>
            <span className="download-stack-sub">💥 80% Off PDF</span>
          </div>
          <div className="download-stack-arrow d-flex align-items-center justify-content-center">
            <FaDownload size={11} />
          </div>
        </div>
      </a>

      <footer className="footer-bg foot-pad border-top">
        <Container>
          <Row>
            <Col lg="12" className="border-bottom pb-4">
              <Row className="g-4 align-items-stretch">
                {/* Column 1: Contact Information */}
                <Col lg="4" md="6" className="py-2">
                  <div className="footer-card h-100 p-3 rounded-3 shadow-sm bg-light border">
                    <h5 className="bold text-danger d-flex align-items-center gap-2 mb-3 pb-2 border-bottom">
                      <FaMapMarkerAlt className="text-danger" /> Contact Information
                    </h5>

                    <div className="mb-3">
                      <div className="bold text-dark small text-uppercase letter-spacing-1 mb-1">
                        Factory & Shop Location:
                      </div>
                      <p className="regular text-muted mb-0 small lh-base">
                        D. No: 3/347c1/1, Maraneri, Sivakasi to Alangulam Main Road, Singampatti, Sivakasi, Tamil Nadu - 626124
                      </p>
                    </div>

                    <div className="mb-3">
                      <div className="bold text-dark small text-uppercase letter-spacing-1 mb-1 d-flex align-items-center gap-2">
                        <FaEnvelope className="text-primary small" /> Email Us:
                      </div>
                      <a href="mailto:gmrcrackers@gmail.com" className="regular text-primary small text-decoration-none fw-semibold">
                        gmrcrackers@gmail.com
                      </a>
                    </div>

                    <div>
                      <div className="bold text-dark small text-uppercase letter-spacing-1 mb-1 d-flex align-items-center gap-2">
                        <FaPhoneAlt className="text-success small" /> Phone Numbers:
                      </div>
                      <div className="d-flex flex-wrap gap-2 mt-1">
                        <a href="tel:+919843058048" className="badge bg-white text-dark border px-2 py-1 text-decoration-none small fw-semibold">
                          +91 98430 58048
                        </a>
                        <a href="tel:+917358866226" className="badge bg-white text-dark border px-2 py-1 text-decoration-none small fw-semibold">
                          +91 73588 66226
                        </a>
                        <a href="tel:+919976858631" className="badge bg-white text-dark border px-2 py-1 text-decoration-none small fw-semibold">
                          +91 99768 58631
                        </a>
                      </div>
                    </div>
                  </div>
                </Col>

                {/* Column 2: Logo & Brand Trust */}
                <Col lg="4" md="6" className="py-2 text-center d-flex flex-column justify-content-center">
                  <div className="p-3">
                    <div className="ft-logo mx-auto mb-3">
                      <img
                        src={require("../../assets/images/banner/logo.png")}
                        className="img-fluid"
                        alt="GMR Crackers Logo"
                        style={{ maxHeight: "110px", objectFit: "contain" }}
                      />
                    </div>
                    <h5 className="bold text-dark mb-1">GMR CRACKERS</h5>
                    <p className="regular text-muted small mb-2">
                      Sivakasi's Trusted Fireworks Manufacturer & Direct Wholesaler
                    </p>
                    <div className="d-flex justify-content-center flex-wrap gap-1 mt-2">
                      <span className="badge bg-success-subtle text-success border border-success-subtle px-2 py-1 small fw-semibold">
                        ✓ 100% Legal & Safe
                      </span>
                      <span className="badge bg-danger-subtle text-danger border border-danger-subtle px-2 py-1 small fw-semibold">
                        ✓ Sivakasi Factory Direct
                      </span>
                      <span className="badge bg-primary-subtle text-primary border border-primary-subtle px-2 py-1 small fw-semibold">
                        ✓ Best 80% Discount
                      </span>
                    </div>
                  </div>
                </Col>

                {/* Column 3: Scan to Pay / UPI Google Pay Card */}
                <Col lg="4" md="12" className="py-2">
                  <div className="footer-card payment-qr-card p-3 rounded-3 shadow-sm bg-white border h-100 text-center">
                    <div className="d-flex align-items-center justify-content-between mb-2 pb-1 border-bottom">
                      <span className="bold text-dark d-flex align-items-center gap-1">
                        <FaQrcode className="text-primary" /> Scan to Pay
                      </span>
                      <span className="badge bg-danger text-white d-flex align-items-center gap-1">
                        <SiGooglepay size={16} /> All UPI Apps
                      </span>
                    </div>

                    {/* QR Code Tab Selector */}
                    <div className="btn-group btn-group-sm w-100 mb-2" role="group">
                      <button
                        type="button"
                        className={`btn py-1 ${activeQr === "primary" ? "btn-primary fw-bold" : "btn-outline-secondary"}`}
                        onClick={() => setActiveQr("primary")}
                      >
                        GMR Crackers
                      </button>
                      <button
                        type="button"
                        className={`btn py-1 ${activeQr === "alternate" ? "btn-primary fw-bold" : "btn-outline-secondary"}`}
                        onClick={() => setActiveQr("alternate")}
                      >
                        Alternate QR
                      </button>
                    </div>

                    {/* QR Code Display */}
                    <div className="qr-image-wrapper p-2 bg-light rounded-3 border d-inline-block mx-auto mb-2 shadow-sm" style={{ width: "100%", maxWidth: "210px" }}>
                      {activeQr === "primary" ? (
                        <img
                          src={require("../../assets/images/gpay_qr.jpg")}
                          alt="GMR Crackers Google Pay QR"
                          className="img-fluid rounded"
                          style={{ width: "100%", height: "auto", objectFit: "contain", display: "block" }}
                        />
                      ) : (
                        <img
                          src={require("../../assets/images/gmr .jpeg")}
                          alt="Alternate Google Pay QR"
                          className="img-fluid rounded"
                          style={{ width: "100%", height: "auto", objectFit: "contain", display: "block" }}
                        />
                      )}
                    </div>

                    {/* UPI ID Display & Copy Button */}
                    <div className="upi-chip-box d-flex align-items-center justify-content-between p-2 rounded bg-light border">
                      <div className="text-start pe-1" style={{ overflow: "hidden" }}>
                        <div className="text-muted" style={{ fontSize: "11px", fontWeight: "600" }}>
                          {activeQr === "primary" ? "GMR CRACKERS UPI ID" : "ALTERNATE UPI ID"}
                        </div>
                        <div className="bold text-dark text-truncate small" title={currentUpi}>
                          {currentUpi}
                        </div>
                      </div>
                      <button
                        onClick={handleCopyUpi}
                        className={`btn btn-sm ${copied ? "btn-success" : "btn-outline-primary"} py-1 px-2 d-flex align-items-center gap-1`}
                        title="Copy UPI ID"
                      >
                        {copied ? <FaCheck size={12} /> : <FaCopy size={12} />}
                        <span style={{ fontSize: "12px" }}>{copied ? "Copied!" : "Copy"}</span>
                      </button>
                    </div>

                    <div className="text-muted mt-2" style={{ fontSize: "11.5px" }}>
                      Scan via GPay, PhonePe, Paytm, or BHIM
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>

            {/* Full-Width Download Price List 2026 Banner in Footer */}
            <Col lg="12" className="pt-3 pb-2">
              <div className="footer-download-banner p-3 p-md-4 rounded-4 text-center text-md-start d-flex flex-column flex-md-row align-items-center justify-content-between gap-3 shadow">
                <div className="d-flex align-items-center gap-3">
                  <div
                    className="bg-warning text-dark p-3 rounded-circle shadow-sm flex-shrink-0 d-flex align-items-center justify-content-center"
                    style={{ width: "54px", height: "54px" }}
                  >
                    <FaFilePdf size={26} className="text-danger" />
                  </div>
                  <div>
                    <div className="d-flex align-items-center gap-2 flex-wrap justify-content-center justify-content-md-start mb-1">
                      <h5 className="bold text-white mb-0">Download GMR Crackers 2026 Price List</h5>
                      <span className="badge bg-warning text-dark bold px-2 py-1 rounded-pill" style={{ fontSize: "11px" }}>
                        💥 80% FLAT DISCOUNT
                      </span>
                    </div>
                    <p className="text-white-50 mb-0 small">
                      Official 6-page comprehensive catalog with Tamil & English product names, net rates, and discounted prices for Diwali 2026.
                    </p>
                  </div>
                </div>
                <a
                  href="/gmr_crackers_pricelist_2026.pdf"
                  download="GMR_Crackers_Price_List_2026.pdf"
                  className="btn btn-warning btn-lg rounded-pill px-4 py-2 bold shadow d-flex align-items-center gap-2 flex-shrink-0 download-nav-btn"
                >
                  <FaDownload className="download-bounce-icon" size={16} />
                  <span>Download Price List 2026 (PDF)</span>
                </a>
              </div>
            </Col>

            {/* Quick Links */}
            <Col lg="12" className="py-3 mx-auto text-center">
              <ul className="footer-nav-list list-unstyled d-flex flex-wrap justify-content-center gap-3 gap-md-4 mb-0">
                <li>
                  <Link to="/home" className="footer-nav-link bold">Home</Link>
                </li>
                <li>
                  <Link to="/about" className="footer-nav-link bold">About Us</Link>
                </li>
                <li>
                  <Link to="/" className="footer-nav-link bold text-danger">Products & Price List</Link>
                </li>
                <li>
                  <Link to="/safetytips" className="footer-nav-link bold">Safety Tips</Link>
                </li>
                <li>
                  <Link to="/contact" className="footer-nav-link bold">Contact Us</Link>
                </li>
                <li>
                  <Link to="/chitsfunds" className="footer-nav-link bold text-warning-emphasis">Chit Funds</Link>
                </li>
              </ul>
            </Col>

            {/* Supreme Court Compliance Notice */}
            <Col lg="12" className="pt-2 pb-3">
              <div className="rules p-3 rounded bg-light border text-muted small text-justify">
                <div className="d-flex align-items-center gap-2 mb-2 bold text-dark">
                  <FaShieldAlt className="text-warning" />
                  <span>Supreme Court Compliance & Legal Disclaimer</span>
                </div>
                As per 2018 Supreme Court order, online sale of firecrackers is not permitted. We value our customers and strictly respect legal jurisdiction. Please add your preferred products to the cart and submit your requirements via the enquiry button. Our team will contact you within 24 hours to confirm your order via WhatsApp or phone call. GMR Crackers follows 100% legal & statutory compliances, and all our shops and godowns strictly adhere to the Explosives Act. Orders are dispatched through registered and licensed transport logistics providers.
              </div>
            </Col>
          </Row>
        </Container>
      </footer>

      {/* Copyright Bar */}
      <div className="mark-bg py-3 border-top border-secondary">
        <Container>
          <Row>
            <Col lg="12" className="text-center">
              <div className="regular text-white small">
                Copyright © 2024 <strong className="bold text-white">GMR Crackers</strong>. All rights reserved.
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Footer;

